"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BilateralTrade = void 0;
var typeorm_1 = require("typeorm");
var Team_entity_1 = require("./Team.entity");
var Market_entity_1 = require("./Market.entity");
var BilateralTrade = /** @class */ (function () {
    function BilateralTrade() {
    }
    __decorate([
        (0, typeorm_1.PrimaryGeneratedColumn)(),
        __metadata("design:type", Number)
    ], BilateralTrade.prototype, "id", void 0);
    __decorate([
        (0, typeorm_1.Column)({ default: 'BilateralTrade' }),
        __metadata("design:type", String)
    ], BilateralTrade.prototype, "type", void 0);
    __decorate([
        (0, typeorm_1.ManyToOne)(function () { return Team_entity_1.BaseTeam; }, function (team) { return team.teamID; }),
        (0, typeorm_1.JoinColumn)({ name: 'offeringTeam' }),
        __metadata("design:type", Team_entity_1.BaseTeam)
    ], BilateralTrade.prototype, "offeringTeam", void 0);
    __decorate([
        (0, typeorm_1.ManyToOne)(function () { return Team_entity_1.BaseTeam; }, function (team) { return team.teamID; }, { nullable: true }),
        (0, typeorm_1.JoinColumn)({ name: 'receivingTeam' }),
        __metadata("design:type", Object)
    ], BilateralTrade.prototype, "receivingTeam", void 0);
    __decorate([
        (0, typeorm_1.Column)(),
        __metadata("design:type", String)
    ], BilateralTrade.prototype, "tradeType", void 0);
    __decorate([
        (0, typeorm_1.ManyToOne)(function () { return Market_entity_1.Market; }, function (market) { return market.marketID; }),
        (0, typeorm_1.JoinColumn)({ name: 'market' }),
        __metadata("design:type", Market_entity_1.Market)
    ], BilateralTrade.prototype, "market", void 0);
    __decorate([
        (0, typeorm_1.Column)(),
        __metadata("design:type", String)
    ], BilateralTrade.prototype, "dealType", void 0);
    __decorate([
        (0, typeorm_1.Column)(),
        __metadata("design:type", Number)
    ], BilateralTrade.prototype, "volume", void 0);
    __decorate([
        (0, typeorm_1.Column)(),
        __metadata("design:type", Number)
    ], BilateralTrade.prototype, "price", void 0);
    __decorate([
        (0, typeorm_1.Column)(),
        __metadata("design:type", String)
    ], BilateralTrade.prototype, "status", void 0);
    __decorate([
        (0, typeorm_1.CreateDateColumn)(),
        __metadata("design:type", Date)
    ], BilateralTrade.prototype, "createdAt", void 0);
    __decorate([
        (0, typeorm_1.Column)({ default: null, nullable: true }),
        __metadata("design:type", Date)
    ], BilateralTrade.prototype, "tradedAt", void 0);
    __decorate([
        (0, typeorm_1.Column)(),
        __metadata("design:type", Number)
    ], BilateralTrade.prototype, "startRoundID", void 0);
    __decorate([
        (0, typeorm_1.Column)(),
        __metadata("design:type", Number)
    ], BilateralTrade.prototype, "endRoundID", void 0);
    __decorate([
        (0, typeorm_1.Column)({ default: null, nullable: true, type: String }),
        __metadata("design:type", Object)
    ], BilateralTrade.prototype, "token", void 0);
    BilateralTrade = __decorate([
        (0, typeorm_1.Entity)('bilateral_trades')
    ], BilateralTrade);
    return BilateralTrade;
}());
exports.BilateralTrade = BilateralTrade;
//# sourceMappingURL=BilateralTrade.entity.js.map